import React from "react";

/** Read-only summary block for the review step. rows: [{ label, value, full }] */
const ReviewCard = ({ title, onEdit, rows, children }) => (
  <div className="fk-review">
    <div className="fk-review__head">
      <h3 className="fk-review__title">{title}</h3>
      {onEdit && (
        <button type="button" className="fk-review__edit" onClick={onEdit}>
          Edit
        </button>
      )}
    </div>
    {rows && (
      <dl className="fk-review__rows">
        {rows.map((r) => (
          <div key={r.label} className="fk-review__row" style={r.full ? { gridColumn: "1 / -1" } : undefined}>
            <dt>{r.label}</dt>
            <dd>{r.value === "" || r.value == null ? "—" : r.value}</dd>
          </div>
        ))}
      </dl>
    )}
    {children}
  </div>
);

export default ReviewCard;
